import posthog from 'posthog-js';
import { loadScript } from './scriptLoader';
import * as Sentry from '@sentry/nextjs';
import { LandingError } from '@/types/errors';
import { TrackingParams } from '@/types';
export const fetchTIH = async (params: URLSearchParams, url: string) => {
	// total injury help landing
	const advertId = params.get('affid') || 63;

	const baseUrl = 'https://tort-api-prod-gateway-66vmvl0o.ue.gateway.dev';

	try {
		const landingResponse = await fetch(`${baseUrl}/landing?page_id=${url}&adv_id=${advertId}`);
		const data = await landingResponse.json();

		posthog.capture('landing-api-response', {
			success: landingResponse.ok,
			baseUrl,
		});

		return data;
	} catch (err) {
		posthog.capture('landing-api-response', {
			success: false,
			baseUrl,
		});

		Sentry.withScope((scope) => {
			scope.setTag('api', 'landingAPI');
			scope.setLevel('error');
			Sentry.captureException(new LandingError(err as Error));
		});

		return {};
	}
};

export const isGtmLoaded = () => {
	if (typeof window === 'undefined') {
		return false;
	}

	window.dataLayer = window.dataLayer || [];
	const gtmStartedEvent = window.dataLayer.find((element) => element?.gtm?.start);

	if (!gtmStartedEvent) {
		return false; // Not even the GTM inline config has executed
	} else if (!gtmStartedEvent.gtm?.uniqueEventId) {
		// GTM inline config has ran, but main GTM js is not loaded
		// (likely AdBlock, NoScript, URL blocking etc.)
		return false;
	}

	return true; // GTM is fully loaded and working
};

export const getTrackingParams = (): TrackingParams => {
	const currentParams = new URLSearchParams(window.location.search);

	return {
		fbclid: currentParams.get('fbclid') || '',
		gclid: currentParams.get('gclid') || '',
		wbraid: currentParams.get('wbraid') || '',
		gbraid: currentParams.get('gbraid') || '',
		rdt_cid: currentParams.get('rdt_cid') || '',
	};
};

export const loadGTM = (tag: string) => {
	loadScript(
		{
			src: `https://www.googletagmanager.com/gtag/js?id=${tag}`,
			bundleId: tag,
			success: () => {
				window.dataLayer = window.dataLayer || [];
				function gtag() {
					// @ts-expect-error: gtag hates typescript
					// eslint-disable-next-line prefer-rest-params
					dataLayer.push(arguments);
				}
				// @ts-expect-error: gtag hates typescript
				gtag('js', new Date());
				// @ts-expect-error: gtag hates typescript
				gtag('config', tag);
			},
			mustBeFirst: true,
		},
		tag,
	);
};

export const pushVWO = () => {
	window.VWO = window.VWO || [];
	window.VWO?.push([
		'onEventReceive',
		'vA',
		(vwoData: Array<string>) => {
			// To fetch A/B test id
			const experimentId = vwoData[1];
			// To fetch A/B test active variation name
			const variationId = vwoData[2];
			// To get A/B test name
			// @ts-expect-error: vwo hates typescript
			const abTestName = _vwo_exp[experimentId].name;
			// To get A/B test active variation name
			// @ts-expect-error: vwo hates typescript
			const variationName = _vwo_exp[experimentId].comb_n[variationId];

			if (
				// @ts-expect-error: vwo hates typescript
				typeof _vwo_exp[experimentId].comb_n[variationId] !== 'undefined' &&
				[
					'VISUAL_AB',
					'VISUAL',
					'SPLIT_URL',
					'SURVEY',
					// @ts-expect-error: vwo hates typescript
				].indexOf(_vwo_exp[experimentId].type) > -1
			) {
				const hidden = document.querySelector('#hidden-form-data');
				const i = document.createElement('input');
				const h = document.createElement('input');

				i.type = 'hidden';
				i.name = 'abTestName';
				i.id = 'abTestName';
				i.value = abTestName;

				h.type = 'hidden';
				h.name = 'variationName';
				h.id = 'variationName';
				h.value = variationName;

				hidden?.appendChild(i);
				hidden?.appendChild(h);

				if (window) {
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						event: 'vwo_page_view',
						abTestName,
						variationName,
					});
					posthog.setPersonProperties({
						VWO_AB_TEST_NAME: abTestName,
						VWO_VARIATION_NAME: variationName,
						VWO_EXPERIMENT_ID: experimentId,
						VWO_VARIATION_ID: variationId,
					});
				}
			}
		},
	]);
};
